import { Link as RouterLink } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import {
  usePolicyScoreCard,
  UsePolicyScoreCardProps,
} from "../../hooks/usePolicyScoreCard";
import { PolicyResultDistribution } from "./PolicyResultDistribution";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { ImpactUpdated } from "~/components/impact/Updated/impact-updated";

type Props = {
  scope: SpaceOrWorkspaceScope;
  policyScorecard: UsePolicyScoreCardProps["policyScorecard"];
  isCicd?: UsePolicyScoreCardProps["isCicd"];
};

export function PolicyScoreCard({ scope, policyScorecard, isCicd }: Props) {
  const { byMondoo, icon, policyName, policyHref, scoreStats, isPreviewMode } =
    usePolicyScoreCard({
      scope,
      policyScorecard,
      isCicd,
    });

  return (
    <Grid
      container
      component={RouterLink}
      to={policyHref}
      rowGap={3}
      sx={{
        py: 3,
        borderRadius: 2,
        backgroundColor: "background.paper",
        justifyContent: "space-between",
        boxShadow: (theme) => theme.shadows[1],
        opacity: isPreviewMode ? 0.4 : 1,
      }}
    >
      <Grid container columnGap={1} sx={{ px: 3 }} size={12}>
        <Grid size="auto">{icon}</Grid>
        <Grid size="grow">
          <Typography fontWeight={700}>{policyName}</Typography>
          {byMondoo && (
            <Typography
              sx={{
                color: "#BDBDBD",
                fontSize: (theme) => theme.spacing(1.5),
                fontWeight: 700,
              }}
            >
              Official - by Mondoo
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid
        gap={2}
        sx={{
          display: "flex",
          px: 3,
          alignItems: "flex-end",
        }}
        size={12}
      >
        <ImpactUpdated
          impact={{
            value: policyScorecard.score.riskValue,
            rating: policyScorecard.score.riskRating,
          }}
          isRiskScore
          hideTooltip
          contained
          isActive={!isPreviewMode}
        />
        <Grid container columns={10} size={12}>
          {scoreStats.map((item) => (
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              key={item.result}
              size={2}
            >
              <PolicyResultDistribution result={item} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
